/**
*  AUTHOR : SOHAN
*  WEBSITE :  sca.pearlgreen.com
*  DATE : 20-05-2019
*/

//@MODULE CharitableDonations

define('CharitableDonations'
,   [
      'CharitableDonations.Router'
   ]
,  function (
      CharitableDonationsRouter
   )
{
   'use strict';

   return   {
      mountToApp: function (application)
      {
         // Initializes the router
         return new CharitableDonationsRouter(application);
      }
   };
});
